/**
 * @generated SignedSource<<20024b220b8a541a9be780307ef83ee2>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export interface ActivitiesArguments {
  accountIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  cloudIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  products?: InputMaybe<Array<ActivityProduct>>;
  eventTypes?: InputMaybe<Array<ActivityEventType>>;
  objectTypes?: InputMaybe<Array<ActivitiesObjectType>>;
  transitions?: InputMaybe<Array<ActivityTransition>>;
  containerIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  earliestStart?: InputMaybe<Scalars["String"]["input"]>;
  latestStart?: InputMaybe<Scalars["String"]["input"]>;
}
export enum ActivitiesObjectType {
  ISSUE = "ISSUE",
  PAGE = "PAGE",
  BLOGPOST = "BLOGPOST",
  WHITEBOARD = "WHITEBOARD",
  DATABASE = "DATABASE",
  EMBED = "EMBED",
}
export enum ActivityEventType {
  ASSIGNED = "ASSIGNED",
  UNASSIGNED = "UNASSIGNED",
  VIEWED = "VIEWED",
  COMMENTED = "COMMENTED",
  UPDATED = "UPDATED",
  CREATED = "CREATED",
  LIKED = "LIKED",
  TRANSITIONED = "TRANSITIONED",
  PUBLISHED = "PUBLISHED",
  EDITED = "EDITED",
}
export enum ActivityProduct {
  JIRA = "JIRA",
  JIRA_BUSINESS = "JIRA_BUSINESS",
  JIRA_SOFTWARE = "JIRA_SOFTWARE",
  JIRA_OPS = "JIRA_OPS",
  JIRA_SERVICE_DESK = "JIRA_SERVICE_DESK",
  CONFLUENCE = "CONFLUENCE",
}
export interface ActivityTransition {
  from?: InputMaybe<Scalars["String"]["input"]>;
  to?: InputMaybe<Scalars["String"]["input"]>;
}
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedPeople_RecommendedPeopleItem_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    accountId: string | null;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedPeople_RecommendedPeopleItem_user_AtlassianUser_photos_AtlassianUserPhoto =
  {
    __typename?: "AtlassianUserPhoto";
    value: string | null;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedPeople_RecommendedPeopleItem_user_AtlassianUser =
  {
    __typename?: "AtlassianUser";
    id: string | null;
    displayName: string | null;
    confluence: AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedPeople_RecommendedPeopleItem_user_AtlassianUser_confluence_ConfluenceUser | null;
    photos: Array<AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedPeople_RecommendedPeopleItem_user_AtlassianUser_photos_AtlassianUserPhoto | null> | null;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedPeople_RecommendedPeopleItem =
  {
    __typename?: "RecommendedPeopleItem";
    score: number;
    user: AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedPeople_RecommendedPeopleItem_user_AtlassianUser | null;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedSpaces_RecommendedSpaceItem_space_Space_icon_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedSpaces_RecommendedSpaceItem_space_Space =
  {
    __typename?: "Space";
    id: string | null;
    key: string | null;
    name: string | null;
    icon: AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedSpaces_RecommendedSpaceItem_space_Space_icon_Icon | null;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedSpaces_RecommendedSpaceItem =
  {
    __typename?: "RecommendedSpaceItem";
    score: number;
    space: AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedSpaces_RecommendedSpaceItem_space_Space | null;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures =
  {
    __typename?: "SmartUserFeatures";
    recommendedPeople: Array<AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedPeople_RecommendedPeopleItem | null> | null;
    recommendedSpaces: Array<AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures_recommendedSpaces_RecommendedSpaceItem | null> | null;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult =
  {
    __typename?: "SmartFeaturesUserResult";
    id: string;
    features: AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult_features_SmartUserFeatures;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesPageResultResponse =
  {
    __typename?: "SmartFeaturesPageResultResponse";
    entityType: string;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesSpaceResultResponse =
  {
    __typename?: "SmartFeaturesSpaceResultResponse";
    entityType: string;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse =
  {
    __typename?: "SmartFeaturesUserResultResponse";
    entityType: string;
    result: Array<AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse_result_SmartFeaturesUserResult | null> | null;
  };
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results =

    | AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesPageResultResponse
    | AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesSpaceResultResponse
    | AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results_SmartFeaturesUserResultResponse;
export type AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse = {
  __typename?: "SmartFeaturesResponse";
  results: Array<AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse_results | null> | null;
};
export type AdvancedSearchFilterQuery_spaces_PaginatedSpaceList_nodes_Space_icon_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type AdvancedSearchFilterQuery_spaces_PaginatedSpaceList_nodes_Space = {
  __typename?: "Space";
  id: string | null;
  key: string | null;
  name: string | null;
  icon: AdvancedSearchFilterQuery_spaces_PaginatedSpaceList_nodes_Space_icon_Icon | null;
};
export type AdvancedSearchFilterQuery_spaces_PaginatedSpaceList = {
  __typename?: "PaginatedSpaceList";
  nodes: Array<AdvancedSearchFilterQuery_spaces_PaginatedSpaceList_nodes_Space | null> | null;
};
export type AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    profilePicture: AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    profilePicture: AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_UnknownUser =
  {
    __typename?: "UnknownUser";
    accountId: string | null;
    displayName: string | null;
    profilePicture: AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_User =
  {
    __typename?: "User";
    accountId: string | null;
    displayName: string | null;
    profilePicture: AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes =

    | AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous
    | AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_KnownUser
    | AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_UnknownUser
    | AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes_User;
export type AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList = {
  __typename?: "PaginatedPersonList";
  nodes: Array<AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList_nodes | null> | null;
};
export type AdvancedSearchFilterQuery_contentTypes_Confluence_cqlMetaData_cqlContentTypes_CQLDisplayableType =
  {
    __typename?: "CQLDisplayableType";
    type: string | null;
    label: string | null;
  };
export type AdvancedSearchFilterQuery_contentTypes_Confluence_cqlMetaData = {
  __typename?: "Confluence_cqlMetaData";
  cqlContentTypes: Array<AdvancedSearchFilterQuery_contentTypes_Confluence_cqlMetaData_cqlContentTypes_CQLDisplayableType | null>;
};
export type AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content =
  {
    __typename?: "Content";
    id: string | null;
    title: string | null;
    type: string | null;
  };
export type AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject =
  {
    __typename?: "ActivitiesObject";
    id: string;
    content: AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content | null;
  };
export type AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem =
  {
    __typename?: "ActivitiesItem";
    id: string;
    object: AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject | null;
  };
export type AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_edges_ActivityEdge =
  {
    __typename?: "ActivityEdge";
    cursor: string;
    node: AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem | null;
  };
export type AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_pageInfo_ActivityPageInfo =
  {
    __typename?: "ActivityPageInfo";
    hasNextPage: boolean;
  };
export type AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection =
  {
    __typename?: "ActivitiesConnection";
    edges: Array<AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_edges_ActivityEdge | null> | null;
    pageInfo: AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection_pageInfo_ActivityPageInfo;
  };
export type AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities =
  {
    __typename?: "MyActivities";
    viewed: AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities_viewed_ActivitiesConnection | null;
  };
export type AdvancedSearchFilterQuery_activities_Activities = {
  __typename?: "Activities";
  myActivities: AdvancedSearchFilterQuery_activities_Activities_myActivities_MyActivities | null;
};
export type AdvancedSearchFilterQuery_ancestorData_Content = {
  __typename?: "Content";
  id: string | null;
  title: string | null;
  type: string | null;
};
export type AdvancedSearchFilterQuery_currentUser_AtlassianUser_photos_AtlassianUserPhoto =
  {
    __typename?: "AtlassianUserPhoto";
    value: string | null;
    isPrimary: boolean | null;
  };
export type AdvancedSearchFilterQuery_currentUser_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    accountId: string | null;
  };
export type AdvancedSearchFilterQuery_currentUser_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  displayName: string | null;
  photos: Array<AdvancedSearchFilterQuery_currentUser_AtlassianUser_photos_AtlassianUserPhoto | null> | null;
  confluence: AdvancedSearchFilterQuery_currentUser_AtlassianUser_confluence_ConfluenceUser | null;
};
export type AdvancedSearchFilterQuery_Query = {
  __typename?: "Query";
  getSmartFeatures?: AdvancedSearchFilterQuery_getSmartFeatures_SmartFeaturesResponse;
  spaces?: AdvancedSearchFilterQuery_spaces_PaginatedSpaceList | null;
  confluenceUsers?: AdvancedSearchFilterQuery_confluenceUsers_PaginatedPersonList | null;
  contentTypes: AdvancedSearchFilterQuery_contentTypes_Confluence_cqlMetaData | null;
  activities?: AdvancedSearchFilterQuery_activities_Activities | null;
  ancestorData?: AdvancedSearchFilterQuery_ancestorData_Content | null;
  currentUser?: AdvancedSearchFilterQuery_currentUser_AtlassianUser | null;
};
export type AdvancedSearchFilterQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
  isAnon: Scalars["Boolean"]["input"];
  accountIds?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  spaceKeys?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  ancestorId?: InputMaybe<Scalars["ID"]["input"]>;
  hasUsers: Scalars["Boolean"]["input"];
  hasSpaces: Scalars["Boolean"]["input"];
  hasAncestor: Scalars["Boolean"]["input"];
  filter: ActivitiesArguments;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;
export type AdvancedSearchFilterQuery = AdvancedSearchFilterQuery_Query;
